import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import { LoginPage } from "./pages/auth/LogInPage";
import { HomePage } from "./pages/homePage/HomePage";
import {
  checkAuthLoader,
  DashBoardPage,
} from "./pages/dashboard/DashBoardPage";

import { ErrorPage } from "./pages/error/ErrorPage";
import { RootLayout } from "./pages/RootLayout";
import { AdvertisementPage } from "./pages/advertisement/AdvertisementPage";
import { MastersOutlet } from "./pages/master/MastersOutlet";

import { RetailerPage } from "./pages/retailer/RetailerPage";

import { MasterSparesPage } from "./pages/master/masterSparesPage/MasterSparesPage";
import { RetailerListPage } from "./pages/retailer/retailerList/RetailerListPage";
import { RetailerDetailPage } from "./pages/retailer/retailerDetail/RetailerDetailPage";
import { MasterSparesListPage } from "./pages/master/masterSparesPage/masterSparesListPage/MasterSparesListPage";
import { MasterSparesVariantPage } from "./pages/master/masterSparesPage/masterSparesVariantPage/MasterSparesVariantPage";
import { MasterSparesVariantDetailPage } from "./pages/master/masterSparesPage/masterSparesVariantPage/masterSparesVariantDetailPage/MasterSparesVariantDetailPage";
import { MasterSpareform } from "./pages/master/masterSparesPage/masterSpareForm/MasterSpareForm";
import { AdvertisementDetailPage } from "./pages/advertisement/advertisementDetail/AdvertisementDetailPage";
import { AdvertisementListPage } from "./pages/advertisement/AdvertisementListPage";
import { InventoryOutlet } from "./pages/inventory/InventoryOutlet";
import { InventorySparesListingPage } from "./pages/inventory/inventorySparesPage/inventorySparesListingPage/InventorySparesListingPage";
import { InventorySparesOutlet } from "./pages/inventory/inventorySparesPage/InventorySparesOutlet";
import { InventorySparesLotListPage } from "./pages/inventory/inventorySparesLotListPage/InventorySparesLotListPage";
import { InventorySparesLotItemDetailPage } from "./pages/inventory/inventorySparesLotListPage/inventorySparesLotListTable/inventorySparesLotItemDetailPage/InventorySparesLotItemDetailPage";
import { BlogsOutlet } from "./pages/blogs/BlogsOutlet";
import { BlogsListPage } from "./pages/blogs/BlogsListPage";
import { BlogDetailPage } from "./pages/blogs/blogDetailPage/BlogDetailPage";
import { BlogAddFormPage } from "./pages/blogs/blogAddFormPage/BlogAddFormPage";
import { BlogPreviewPage } from "./pages/blogs/blogPreviewPage/BlogPreviewPage";
import { OrderOutlet } from "./pages/order/OrderOulet";

import { OrderListPage } from "./pages/order/OrderListPage";
import { OrderDetailPage } from "./pages/order/orderDetail/OrderDetailPage";
import { CancellationOutlet } from "./pages/cancellation/CancellationOutlet";
import { CancellationListPage } from "./pages/cancellation/CancellationListPage";
import { CancellationDetailPage } from "./pages/cancellation/cancellationDetailPage/CancellationDetailPage";
import { RefundOutlet } from "./pages/refund/RefundOutlet";
import { RefundListPage } from "./pages/refund/RefundListPage";
import { RefundDetailPage } from "./pages/refund/refundDetail/RefundDetailPage";
import { CouponOutlet } from "./pages/coupon/CouponOutlet";
import { CouponListPage } from "./pages/coupon/CouponListPage";
import { CouponDetailPage } from "./pages/coupon/couponDetailPage/CouponDetailPage";
import { CreateCouponFormPage } from "./pages/coupon/couponFormPage/CreateCouponFormPage";
import { CreateAdvertisementPage } from "./pages/advertisement/createAdvertisement/CreateAdvertisementPage";
import { RefundInitiationOutlet } from "./pages/refund_Initiation/RefundInitiationOutlet";
import { RefundInitiationListPage } from "./pages/refund_Initiation/RefundInitiationListPage";
import { RefundInitiationDetailPage } from "./pages/refund_Initiation/refundInitiationDetail/RefundInitiationDetailPage";
import { BulkOutlet } from "./pages/bulk/BulkOutLet";
import { BulkSparesPage } from "./pages/bulk/bulkSpares/BulkSparesPage";
import { BulkSparesListPage } from "./pages/bulk/bulkSpares/bulkSparesList/BulkSparesListPage";
import { BulkSpareHelperOutlet } from "./pages/bulk/bulkSpareDetail/BulkSpareHelperOutlet";
import { BulkSpareDetailPage } from "./pages/bulk/bulkSpareDetail/BulkSpareDetailPage";
import { BulkSpareLotListOutlet } from "./pages/bulk/bulkSpareLotList/BulkSpareLotListOutlet";
import { BulkSpareLotListPage } from "./pages/bulk/bulkSpareLotList/BulkSpareLotListPage";
import { BulkSpareLotListItemDetailPage } from "./pages/bulk/bulkSpareLotList/bulkSpareLotListItemDetail/BulkSpareLotListItemDetailPage";
import { TermsAndConditionsPage } from "./pages/termsAndConditions/termsAndConditionsPage";
import { TermsAndConditionsListPage } from "./pages/termsAndConditions/TermsAndConditionsListPage";
import { TermsAndConditionsDetailPage } from "./pages/termsAndConditions/termsAndConditionsDetail/TermsAndConditionsDetailPage";
import { CreateTermsAndConditionsPage } from "./pages/termsAndConditions/createTermsAndConditions/CreateTermsAndConditionsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    loader: checkAuthLoader,
    children: [
      {
        path: "/",
        element: <DashBoardPage />,

        children: [
          { index: true, element: <HomePage /> },

          {
            path: "advertisement",
            element: <AdvertisementPage />,
            children: [
              { index: true, element: <AdvertisementListPage /> },
              {
                path: ":advertisementId",
                element: <AdvertisementDetailPage />,
              },
              { path: "create", element: <CreateAdvertisementPage /> },
            ],
          },
          {
            path: "terms_and_conditions",
            element: <TermsAndConditionsPage />,
            children: [
              { index: true, element: <TermsAndConditionsListPage /> },
              {
                path: ":termsAndConditionsId",
                element: <TermsAndConditionsDetailPage />,
              },
              { path: "create", element: <CreateTermsAndConditionsPage /> },
            ],
          },
          {
            path: "blogs",
            element: <BlogsOutlet />,
            children: [
              { index: true, element: <BlogsListPage /> },
              { path: ":blogId", element: <BlogDetailPage /> },
              { path: ":blogId/preview", element: <BlogPreviewPage /> },
              { path: "add", element: <BlogAddFormPage /> },
              { path: "add/preview", element: <BlogPreviewPage /> },
            ],
          },

          {
            path: "coupons",
            element: <CouponOutlet />,
            children: [
              { index: true, element: <CouponListPage /> },
              { path: ":couponId", element: <CouponDetailPage /> },
              { path: "create", element: <CreateCouponFormPage /> },
            ],
          },

          {
            path: "masters",
            element: <MastersOutlet />,
            children: [
              {
                path: "spares",
                element: <MasterSparesPage />,
                children: [
                  { index: true, element: <MasterSparesListPage /> },
                  {
                    path: "add",
                    element: <MasterSpareform />,
                  },
                  { path: "variants", element: <MasterSparesVariantPage /> },
                  {
                    path: "variants/add",
                    element: <MasterSparesVariantDetailPage />,
                  },
                  {
                    path: "variants/:id",
                    element: <MasterSparesVariantDetailPage />,
                  },
                ],
              },
            ],
          },

          {
            path: "inventory",
            element: <InventoryOutlet />,
            children: [
              {
                path: "spares",
                element: <InventorySparesOutlet />,
                children: [
                  { index: true, element: <InventorySparesListingPage /> },
                  {
                    path: ":inventoryId",
                    element: <InventorySparesLotListPage />,
                  },
                  {
                    path: ":inventoryId/:lotItemId",
                    element: <InventorySparesLotItemDetailPage />,
                  },
                ],
              },
            ],
          },
          {
            path: "bulk_deals",
            element: <BulkOutlet />,
            children: [
              {
                path: "spares",
                element: <BulkSparesPage />,
                children: [
                  { index: true, element: <BulkSparesListPage /> },

                  {
                    path: ":request_id",
                    element: <BulkSpareHelperOutlet />,
                    children: [
                      { index: true, element: <BulkSpareDetailPage /> },
                      {
                        path: "items",
                        element: <BulkSpareLotListOutlet />, // optional outlet for items
                        children: [
                          { index: true, element: <BulkSpareLotListPage /> }, // /bulk_deals/spares/:request_id/items
                          {
                            path: ":item_id",
                            element: <BulkSpareLotListItemDetailPage />, // /bulk_deals/spares/:request_id/items/:item_id
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },

          {
            path: "retailers",
            element: <RetailerPage />,
            children: [
              { index: true, element: <RetailerListPage /> },
              { path: ":retailerId", element: <RetailerDetailPage /> },
            ],
          },
          {
            path: "orders",
            element: <OrderOutlet />,
            children: [
              { index: true, element: <OrderListPage /> },
              { path: ":orderId", element: <OrderDetailPage /> },
            ],
          },
          {
            path: "cancellations",
            element: <CancellationOutlet />,
            children: [
              { index: true, element: <CancellationListPage /> },
              { path: ":cancellationId", element: <CancellationDetailPage /> },
            ],
          },
          {
            path: "refunds",
            element: <RefundOutlet />,
            children: [
              { index: true, element: <RefundListPage /> },
              { path: ":refundId", element: <RefundDetailPage /> },
            ],
          },
          {
            path: "refund_payments",
            element: <RefundInitiationOutlet />,
            children: [
              { index: true, element: <RefundInitiationListPage /> },
              {
                path: ":refundInitiationId",
                element: <RefundInitiationDetailPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  { path: "login", element: <LoginPage /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
